import { BC_STRIDE, type Program } from './types';

export function compile(program: Program): Int32Array {
  const instrs = program.instructions;
  const bc = new Int32Array(instrs.length * BC_STRIDE);

  for (let i = 0; i < instrs.length; i++) {
    const instr = instrs[i];
    const base = i * BC_STRIDE;
    bc[base] = instr.op;

    let flags = 0;
    const ops = instr.operands;
    for (let j = 0; j < ops.length && j < 3; j++) {
      if (ops[j].type === 'reg') flags |= (1 << j);
      bc[base + 2 + j] = ops[j].val;
    }
    bc[base + 1] = flags;
  }

  return bc;
}
